import React, {PureComponent} from "react"
import {DataProxy} from "apollo-cache"
import {QueryResult, Query} from "react-apollo"
import gql from "graphql-tag"

import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {Query as QueryComponent, pagination} from "@irati/utils/services/apollo"
import {CompanyValue} from "../../types"

interface CompanyValuesListQueryVariables {
  limit: number,
  page: number,
  tenantId: string
}

export interface CompanyValuesListQueryData {
  companyValues: {
    results: CompanyValue[],
    total: number
  }
}

type CompanyValuesListQuery = DataProxy.Query<CompanyValuesListQueryVariables>
interface CompanyValuesListResult extends QueryResult<CompanyValuesListQueryData, CompanyValuesListQueryVariables> {
  onLoadMore: () => Promise<CompanyValuesListQuery>
}

interface Props {
  children: (result: CompanyValuesListResult) => React.ReactNode,
  variables: CompanyValuesListQueryVariables,
  setupView: boolean
}

export const query = gql`
  query CompanyValues($limit: Int, $offset: Int, $tenantId: String!) {
    companyValues(limit: $limit, offset: $offset, tenantId: $tenantId) {
      results {
        desc
        name
        tag
        icon {
          href
          alt
        }
        uuid
      }
      count
      offset
      total
    }
  }
`

class TypedQuery extends Query<CompanyValuesListQueryData, CompanyValuesListQueryVariables> {}

export default class RewardsQueryComponent extends PureComponent<Props> {
  static defaultProps = {
    notifyOnNetworkStatusChange: true,
    useError: false,
    useLoader: false
  }

  render() {
    const {children} = this.props

    return (
      <QueryComponent {...this.props} query={query} QueryComponent={TypedQuery}>
        {(apolloState: ApolloState) => {
          const onLoadMore = () =>
            pagination(
              {
                query,
                variables: {
                  limit: this.props.variables.limit,
                  tenantId: this.props.variables.tenantId,
                  offset: apolloState.data.companyValues.offset + 1
                }
              },
              apolloState
            )
          return children({...apolloState, onLoadMore})
        }}
      </QueryComponent>
    )
  }
}
